var map = {
	"./icon-base-white.png": "Mnuv",
	"./icon-doudian-white.png": "Vwln",
	"./icon-kingdee-cloud-white.png": "9eYs",
	"./icon-kingdee-white.png": "A+nv",
	"./icon-money-white.png": "hnXv",
	"./icon-pindd-white.png": "kyBs",
	"./icon-purchase-white.png": "N4DW",
	"./icon-sell-white.png": "6TQQ",
	"./icon-shop-white.png": "5aAb",
	"./icon-state-white.png": "f39L",
	"./icon-sys-white.png": "OOB1",
	"./icon-tmall-white.png": "SuzX",
	"./icon-warehouse-white.png": "a6CD"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9pRE";


//////////////////
// WEBPACK FOOTER
// ./src/assets/menuicon ^\.\/.*\-white\.png$
// module id = 9pRE
// module chunks = 2